import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.75 10.9757C4.33579 10.9757 4 11.3115 4 11.7257C4 12.1399 4.33579 12.4757 4.75 12.4757H17.9338L13.171 17.2189C12.8775 17.5112 12.8765 17.986 13.1688 18.2795C13.4611 18.573 13.9359 18.574 14.2294 18.2817L20.2686 12.2676C20.3814 12.1596 20.4605 12.0167 20.4887 11.8563C20.4963 11.8133 20.5002 11.7695 20.5002 11.7253C20.5002 11.5258 20.4207 11.3346 20.2794 11.1938L14.2294 5.16982C13.9359 4.87756 13.461 4.87858 13.1687 5.17211C12.8765 5.46563 12.8775 5.9405 13.171 6.23277L17.9344 10.9757H4.75Z",
		fill: "currentColor"
	})
});
export default SvgArrowRightLine;
